import { apiClient } from './api';
import { PagedResponse, AuditLog, AuditLogQueryRequest } from '../types/api';

export const auditLogService = {
  getAll: async (params: AuditLogQueryRequest): Promise<PagedResponse<AuditLog>> => {
    const { data } = await apiClient.get('/audit-logs', { params });
    return data;
  },

  getByUser: async (userId: string, params: AuditLogQueryRequest): Promise<PagedResponse<AuditLog>> => {
    const { data } = await apiClient.get(`/audit-logs/user/${userId}`, { params });
    return data;
  },
};
